// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import UtilityProviderDetailPage from '@/features/utility-providers/components/UtilityProviderDetailPage';

export const Route = createFileRoute(
  '/$accountId/_admin/operations/portfolio-analysis/utility-providers/heat/$providerId',
)({
  component: () => <UtilityProviderDetailPage utilityType="heat" />,
});
